import React from "react"
import { Provider } from "react-redux"
import { ReactReduxFirebaseProvider } from "react-redux-firebase"
import { createFirestoreInstance } from "redux-firestore"
import { UserContextProvider } from "./src/context/UserContext"
import configureStore from "./src/store"
import Firebase from "./src/middleware/Firebase"
import { rrfConfig } from "./src/config"
import ClientOnly from "./src/components/ClientOnly"

// eslint-disable-next-line import/no-anonymous-default-export
// eslint-disable-next-line react/display-name
export default function WrapProviders({ element }) {
  const store = configureStore()

  return (
    <Provider store={store}>
      <ClientOnly
        fallback={
          <UserContextProvider renderImmediately={true}>
            {element}
          </UserContextProvider>
        }
      >
        {Firebase ? (
          <ReactReduxFirebaseProvider
            firebase={Firebase}
            config={rrfConfig}
            dispatch={store.dispatch}
            createFirestoreInstance={createFirestoreInstance}
          >
            <UserContextProvider renderImmediately={true}>
              {element}
            </UserContextProvider>
          </ReactReduxFirebaseProvider>
        ) : (
          <UserContextProvider renderImmediately={true}>
            {element}
          </UserContextProvider>
        )}
      </ClientOnly>
    </Provider>
  )
}
